import { render, staticRenderFns } from "./ContexSocial.vue?vue&type=template&id=26d167e2&"
import script from "./ContexSocial.vue?vue&type=script&lang=ts&"
export * from "./ContexSocial.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports